"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getActionClauseTypeOptions_1 = require("../actions/helpers/getActionClauseTypeOptions");
var getConditionalExceptionClauseTypeOptions_1 = require("../actions/helpers/getConditionalExceptionClauseTypeOptions");
var datapoints_1 = require("../actions/datapoints");
var folderIdToName_1 = require("owa-session-store/lib/utils/folderIdToName");
var owa_analytics_1 = require("owa-analytics");
function logInboxRuleInformation(inboxRule, actionSource) {
    var ruleToLog = {};
    var numActionClauses = 0;
    var numConditionalClauses = 0;
    var numExceptionClauses = 0;
    var _a = datapoints_1.default.inboxRuleInformationDatapoint.datapoint, eventName = _a.name, customData = _a.customData;
    // map conditional clauses
    var conditionalExceptionClauseOptions = getConditionalExceptionClauseTypeOptions_1.default();
    var actionClauseOptions = getActionClauseTypeOptions_1.default();
    for (var _i = 0, conditionalExceptionClauseOptions_1 = conditionalExceptionClauseOptions; _i < conditionalExceptionClauseOptions_1.length; _i++) {
        var conditionalClause = conditionalExceptionClauseOptions_1[_i];
        switch (conditionalClause) {
            case 'from':
                if (inboxRule.From) {
                    ruleToLog.NumFrom = inboxRule.From.length;
                    numConditionalClauses++;
                }
                break;
            case 'to':
                if (inboxRule.SentTo) {
                    ruleToLog.NumSentTo = inboxRule.SentTo.length;
                    numConditionalClauses++;
                }
                break;
            case 'onTheToOrCcLine':
                if (inboxRule.MyNameInToOrCcBox) {
                    ruleToLog.MyNameInToOrCcBox = inboxRule.MyNameInToOrCcBox;
                    numConditionalClauses++;
                }
                break;
            case 'theOnlyRecipientListed':
                if (inboxRule.SentOnlyToMe) {
                    ruleToLog.SentOnlyToMe = inboxRule.SentOnlyToMe;
                    numConditionalClauses++;
                }
                break;
            case 'onTheToLine':
                if (inboxRule.MyNameInToBox) {
                    ruleToLog.MyNameInToBox = inboxRule.MyNameInToBox;
                    numConditionalClauses++;
                }
                break;
            case 'onTheCcLine':
                if (inboxRule.MyNameInCcBox) {
                    ruleToLog.MyNameInCcBox = inboxRule.MyNameInCcBox;
                    numConditionalClauses++;
                }
                break;
            case 'notOnTheToLine':
                if (inboxRule.MyNameNotInToBox) {
                    ruleToLog.MyNameNotInToBox = inboxRule.MyNameNotInToBox;
                    numConditionalClauses++;
                }
                break;
            case 'subjectIncludes':
                if (inboxRule.SubjectContainsWords) {
                    ruleToLog.NumSubjectContainsWordsPills = inboxRule.SubjectContainsWords.length;
                    numConditionalClauses++;
                }
                break;
            case 'subjectOrBodyIncludes':
                if (inboxRule.SubjectOrBodyContainsWords) {
                    ruleToLog.NumSubjectOrBodyContainsWordsPills =
                        inboxRule.SubjectOrBodyContainsWords.length;
                    numConditionalClauses++;
                }
                break;
            case 'inTheBody':
                if (inboxRule.BodyContainsWords) {
                    ruleToLog.NumBodyContainsWordsPills = inboxRule.BodyContainsWords.length;
                    numConditionalClauses++;
                }
                break;
            case 'inTheSenderAddress':
                if (inboxRule.FromAddressContainsWords) {
                    ruleToLog.NumFromAddressContainsWordsPills =
                        inboxRule.FromAddressContainsWords.length;
                    numConditionalClauses++;
                }
                break;
            case 'inTheRecipientAddress':
                if (inboxRule.RecipientAddressContainsWords) {
                    ruleToLog.NumRecipientAddressContainsWordsPills =
                        inboxRule.RecipientAddressContainsWords.length;
                    numConditionalClauses++;
                }
                break;
            case 'inTheMessageHeader':
                if (inboxRule.HeaderContainsWords) {
                    ruleToLog.NumHeaderContainsWordsPills = inboxRule.HeaderContainsWords.length;
                    numConditionalClauses++;
                }
                break;
            case 'withImportance':
                if (inboxRule.WithImportance && inboxRule.WithImportance != 'NullImportance') {
                    ruleToLog.WithImportance = inboxRule.WithImportance;
                    numConditionalClauses++;
                }
                break;
            case 'sensitivity':
                if (inboxRule.WithSensitivity && inboxRule.WithSensitivity != 'NullSensitivity') {
                    ruleToLog.WithSensitivity = inboxRule.WithSensitivity;
                    numConditionalClauses++;
                }
                break;
            case 'flag':
                if (inboxRule.FlaggedForAction &&
                    inboxRule.FlaggedForAction != 'NullInboxRuleMessageFlag') {
                    ruleToLog.FlaggedForAction = inboxRule.FlaggedForAction;
                    numConditionalClauses++;
                }
                break;
            case 'type':
                if (inboxRule.MessageTypeMatches &&
                    inboxRule.MessageTypeMatches != 'NullInboxRuleMessageType') {
                    ruleToLog.MessageTypeMatches = inboxRule.MessageTypeMatches;
                    numConditionalClauses++;
                }
                break;
            case 'attachment':
                if (inboxRule.HasAttachment) {
                    ruleToLog.HasAttachment = inboxRule.HasAttachment;
                    numConditionalClauses++;
                }
                break;
        }
    }
    for (var _b = 0, actionClauseOptions_1 = actionClauseOptions; _b < actionClauseOptions_1.length; _b++) {
        var actionClause = actionClauseOptions_1[_b];
        switch (actionClause) {
            case 'moveTo':
                if (inboxRule.MoveToFolder) {
                    // We are only given RawIdentity from the server on the inbox rule, which can't be used to get the folder name
                    if (actionSource == 'GetInboxRules' || actionSource == 'EditInboxRule') {
                        ruleToLog.MoveToFolder = 'unknown';
                    }
                    else {
                        ruleToLog.MoveToFolder ==
                            folderIdToName_1.default(inboxRule.MoveToFolder.RawIdentity);
                    }
                    numActionClauses++;
                }
                break;
            case 'copyTo':
                if (inboxRule.CopyToFolder) {
                    // We are only given RawIdentity from the server on the inbox rule, which can't be used to get the folder name
                    if (actionSource == 'GetInboxRules' || actionSource == 'EditInboxRule') {
                        ruleToLog.MoveToFolder = 'unknown';
                    }
                    else {
                        ruleToLog.CopyToFolder = folderIdToName_1.default(inboxRule.MoveToFolder.RawIdentity);
                    }
                    numActionClauses++;
                }
                break;
            case 'delete':
                if (inboxRule.DeleteMessage) {
                    ruleToLog.DeleteMessage = inboxRule.DeleteMessage;
                    numActionClauses++;
                }
                break;
            case 'pin':
                if (inboxRule.PinMessage) {
                    ruleToLog.PinMessage = inboxRule.PinMessage;
                    numActionClauses++;
                }
                break;
            case 'read':
                if (inboxRule.MarkAsRead) {
                    ruleToLog.MarkAsRead = inboxRule.MarkAsRead;
                    numActionClauses++;
                }
                break;
            case 'markImportance':
                if (inboxRule.MarkImportance && inboxRule.MarkImportance != 'NullImportance') {
                    ruleToLog.MarkImportance = inboxRule.MarkImportance;
                    numActionClauses++;
                }
                break;
            case 'forwardTo':
                if (inboxRule.ForwardTo) {
                    ruleToLog.NumForwardTo = inboxRule.ForwardTo.length;
                    numActionClauses++;
                }
                break;
            case 'forwardAsAttachmentTo':
                if (inboxRule.ForwardAsAttachmentTo) {
                    ruleToLog.NumForwardAsAttachmentTo = inboxRule.ForwardAsAttachmentTo.length;
                    numActionClauses++;
                }
                break;
            case 'redirectTo':
                if (inboxRule.RedirectTo) {
                    ruleToLog.NumRedirectTo = inboxRule.RedirectTo.length;
                    numActionClauses++;
                }
                break;
        }
    }
    for (var _c = 0, conditionalExceptionClauseOptions_2 = conditionalExceptionClauseOptions; _c < conditionalExceptionClauseOptions_2.length; _c++) {
        var exceptionClause = conditionalExceptionClauseOptions_2[_c];
        switch (exceptionClause) {
            case 'from':
                if (inboxRule.ExceptIfFrom) {
                    ruleToLog.NumExceptIfFrom = inboxRule.ExceptIfFrom.length;
                    numExceptionClauses++;
                }
                break;
            case 'to':
                if (inboxRule.ExceptIfSentTo) {
                    ruleToLog.NumExceptIfSentTo = inboxRule.ExceptIfSentTo.length;
                    numExceptionClauses++;
                }
                break;
            case 'onTheToOrCcLine':
                if (inboxRule.ExceptIfMyNameInToOrCcBox) {
                    ruleToLog.ExceptIfMyNameInToOrCcBox = inboxRule.ExceptIfMyNameInToOrCcBox;
                    numExceptionClauses++;
                }
                break;
            case 'theOnlyRecipientListed':
                if (inboxRule.ExceptIfSentOnlyToMe) {
                    ruleToLog.ExceptIfSentOnlyToMe = inboxRule.ExceptIfSentOnlyToMe;
                    numExceptionClauses++;
                }
                break;
            case 'onTheToLine':
                if (inboxRule.ExceptIfMyNameInToBox) {
                    ruleToLog.ExceptIfMyNameInToBox = inboxRule.ExceptIfMyNameInToBox;
                    numExceptionClauses++;
                }
                break;
            case 'onTheCcLine':
                if (inboxRule.ExceptIfMyNameInCcBox) {
                    ruleToLog.ExceptIfMyNameInCcBox = inboxRule.ExceptIfMyNameInCcBox;
                    numExceptionClauses++;
                }
                break;
            case 'notOnTheToLine':
                if (inboxRule.ExceptIfMyNameNotInToBox) {
                    ruleToLog.ExceptIfMyNameNotInToBox = inboxRule.ExceptIfMyNameNotInToBox;
                    numExceptionClauses++;
                }
                break;
            case 'subjectIncludes':
                if (inboxRule.ExceptIfSubjectContainsWords) {
                    ruleToLog.NumExceptIfSubjectContainsWordsPills =
                        inboxRule.ExceptIfSubjectContainsWords.length;
                    numExceptionClauses++;
                }
                break;
            case 'subjectOrBodyIncludes':
                if (inboxRule.ExceptIfSubjectOrBodyContainsWords) {
                    ruleToLog.NumExceptIfSubjectOrBodyContainsWordsPills =
                        inboxRule.ExceptIfSubjectOrBodyContainsWords.length;
                    numExceptionClauses++;
                }
                break;
            case 'inTheBody':
                if (inboxRule.ExceptIfBodyContainsWords) {
                    ruleToLog.NumExceptIfBodyContainsWordsPills =
                        inboxRule.ExceptIfBodyContainsWords.length;
                    numExceptionClauses++;
                }
                break;
            case 'inTheSenderAddress':
                if (inboxRule.ExceptIfFromAddressContainsWords) {
                    ruleToLog.NumExceptIfFromAddressContainsWordsPills =
                        inboxRule.ExceptIfFromAddressContainsWords.length;
                    numExceptionClauses++;
                }
                break;
            case 'inTheRecipientAddress':
                if (inboxRule.ExceptIfRecipientAddressContainsWords) {
                    ruleToLog.NumExceptIfRecipientAddressContainsWordsPills =
                        inboxRule.ExceptIfRecipientAddressContainsWords.length;
                    numExceptionClauses++;
                }
                break;
            case 'inTheMessageHeader':
                if (inboxRule.ExceptIfHeaderContainsWords) {
                    ruleToLog.NumExceptIfHeaderContainsWordsPills =
                        inboxRule.ExceptIfHeaderContainsWords.length;
                    numExceptionClauses++;
                }
                break;
            case 'withImportance':
                if (inboxRule.ExceptIfWithImportance &&
                    inboxRule.ExceptIfWithImportance != 'NullImportance') {
                    ruleToLog.ExceptIfWithImportance = inboxRule.ExceptIfWithImportance;
                    numExceptionClauses++;
                }
                break;
            case 'sensitivity':
                if (inboxRule.ExceptIfWithSensitivity &&
                    inboxRule.ExceptIfWithSensitivity != 'NullSensitivity') {
                    ruleToLog.ExceptIfWithSensitivity = inboxRule.ExceptIfWithSensitivity;
                    numExceptionClauses++;
                }
                break;
            case 'flag':
                if (inboxRule.ExceptIfFlaggedForAction &&
                    inboxRule.ExceptIfFlaggedForAction != 'NullInboxRuleMessageFlag') {
                    ruleToLog.ExceptIfFlaggedForAction = inboxRule.ExceptIfFlaggedForAction;
                    numExceptionClauses++;
                }
                break;
            case 'type':
                if (inboxRule.ExceptIfMessageTypeMatches &&
                    inboxRule.ExceptIfMessageTypeMatches != 'NullInboxRuleMessageType') {
                    ruleToLog.ExceptIfMessageTypeMatches = inboxRule.ExceptIfMessageTypeMatches;
                    numExceptionClauses++;
                }
                break;
            case 'attachment':
                if (inboxRule.ExceptIfHasAttachment) {
                    ruleToLog.ExceptIfHasAttachment = inboxRule.ExceptIfHasAttachment;
                    numExceptionClauses++;
                }
                break;
        }
    }
    ruleToLog.StopProcessingRules = inboxRule.StopProcessingRules;
    owa_analytics_1.logUsage(eventName, customData(ruleToLog, actionSource, numConditionalClauses, numActionClauses, numExceptionClauses));
}
exports.default = logInboxRuleInformation;
//# sourceMappingURL=logInboxRuleInformation.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/utils/logInboxRuleInformation.js
// module id = 3756
// module chunks = 2